import appConfig from 'app-config';

const { env } = appConfig;

const normalisedLobIcons = {
    PA: {
        image: 'personal-auto',
        //   font: 'mi-directions_car'
        font: 'fa fa-car',
        banner: 'Auto_Insurance.jpeg'
    },
    HO: {
        image: 'home-owners',
        //  font: 'mi-home'
        font: 'fa-home',
        banner: 'Residential_Insurance.jpeg'
    },
    GL: {
        image: 'general-liability',
        font: 'fa-tractor',
        banner: 'Auto_Insurance.jpeg'
        // font: 'mi-healing'
    },
    BO: {
        image: 'business-owners',
        // font: 'mi-store'
        font: 'fa-building',
        banner: 'CP_Insurance.jpeg'
    },
    IM: {
        image: 'inland-marine',
        font: 'mi-directions_boat'
        //  font: 'fa-ship'
    },
    CP: {
        image: 'commercial-property',
        font: 'mi-unarchive',
        banner: 'CP_Insurance.jpeg'
    },
    CA: {
        image: 'commercial-auto',
        font: 'fa fa-car',
        banner: 'Auto_Insurance.jpeg'
    },
    WC: {
        image: 'workers-comp',
        font: 'mi-work',
        banner: 'Auto_Insurance.jpeg'
    },
    CPKG: {
        image: 'commercial-package',
        font: 'mi-unarchive'
    },
    TRVL: {
        image: 'travel',
        font: 'mi-plane'
    },
    PUL: {
        image: 'no-icon',
        font: 'fa-umbrella',
        banner: 'CP_Insurance.jpeg'
    },
    BP7: {
        image: 'farm',
        font: 'fa-tractor',
        banner: 'Farm_Insurance.jpeg'
        //  font: 'fa-leaf'
    },
    GA: {
        image: 'garage',
        font: 'fa-warehouse',
        banner: 'Auto_Insurance.jpeg'
    },
    default: {
        image: 'no-icon', // Using an existing empty image as default to avoid 404s
        font: 'mi-receipt',
        banner: 'home_banner_crop.jpg'
    }
};

const lobKeys = {
    PersonalAuto: 'PA',
    PersonalAutoLine: 'PA',
    auto_per: 'PA',
    Homeowners: 'HO',
    homeowners: 'HO',
    HomeOwners: 'HO',
    HomeownersLine_HOE: 'HO',
    HomeownersLine: 'HO',
    HOPLine: 'HO',
    HOLine: 'HO',
    HOPHomeowners: 'HO',
    GeneralLiability: 'GL',
    GeneralLiabilityLine: 'GL',
    GLLine: 'GL',
    Businessowners: 'BO',
    BusinessOwners: 'BO',
    BusinessOwnersLine: 'BO',
    BOPLine: 'BO',
    HOPBoat_EY: 'IM',
    InlandMarine: 'IM',
    InlandMarineLine: 'IM',
    IMLine: 'IM',
    CommercialProperty: 'CP',
    CommercialPropertyLine: 'CP',
    CPLine: 'CP',
    CommercialAuto: 'PA',
    BusinessAuto: 'CA',
    BusinessAutoLine: 'PA',
    WorkersComp: 'WC',
    WorkersCompLine: 'WC',
    WC7WorkersComp: 'WC',
    CommercialPackage: 'CPKG',
    CommercialPackageLine: 'CPKG',
    travel_perLine: 'TRVL',
    PersonalUmbrellaLine: 'PUL',
    PersonalUmbrella: 'PUL',
    BP7Line: 'BP7',
    BP7BusinessOwners: 'BP7',
    BusinessFleet: 'CA',
    GA7Garage: 'GA'
};

const lobProductNameKeys = {
    'Personal Auto': 'PA',
    'Commercial Auto': 'CA',
    'Auto': 'CA',
    'Residential': 'HO',
    'Farm': 'BP7',
    'Umbrella': 'PUL',
    'Marine': 'PA',
    'Commercial Property': 'CP'
};

const applicationPages = {
    DASHBOARD: {
        banner: 'home_banner_crop.jpg'
    },
    CLAIMDETAILS: {
        banner: 'Claims.jpeg'
    },
    MYDOCUMENTS: {
        banner: 'Documents.jpeg'
    },
    FAQ: {
        banner: 'banner-faq.jpg'
    },
    MYCLAIMS: {
        banner: 'Claims.jpeg'
    },
    MYBILLING: {
        banner: 'Billing_crop.jpeg'
    }
};

const getProductName = (productCode) => {
    switch (productCode) {
        case 'HOPHomeowners':
            return 'Residential';
        case 'BusinessAuto':
        case 'personalAuto':
        case 'PersonalAuto':
            return 'Auto';
        case 'BP7BusinessOwners':
            return 'Farm';
        case 'BusinessOwners':
        case 'Businessowners':
            return 'Commercial Property'
        case 'PersonalUmbrella':
        case 'Umbrella':
            return 'Umbrella'
        default:
            return productCode;
    }
};

const getNormalisedObject = (lobCode) => {
    const normalisedKey = lobKeys[lobCode] || lobProductNameKeys[lobCode] || 'default';
    return normalisedLobIcons[normalisedKey];
};

const getImageSrc = (src) => {
    const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');
    return `${prefix}/${src}`;
};

export function getBannerImage(lobCode) {
    return getNormalisedObject(lobCode).banner;
}

function getFontIcon(lobCode) {
    return getNormalisedObject(lobCode).font;
}

export function getPageHeaderImage(pageName) {
    const page = pageName ? pageName.toUpperCase() : 'default';
    return applicationPages[page] ? applicationPages[page].banner : '';
}

export default getFontIcon;

export {
    getImageSrc,
    getFontIcon,
    getProductName
}
